export type DepositRewardSchedulePeriod = {
  fromDay: bigint;
  toDay: bigint;
  numerator: bigint;
  denominator: bigint;
};

export const depositRewardWithdrawalSchedule = [
  { fromDay: BigInt(1), toDay: BigInt(7), numerator: BigInt(5), denominator: BigInt(1000) },
  { fromDay: BigInt(8), toDay: BigInt(14), numerator: BigInt(10), denominator: BigInt(1000) },
  { fromDay: BigInt(15), toDay: BigInt(21), numerator: BigInt(15), denominator: BigInt(1000) },
  { fromDay: BigInt(22), toDay: BigInt(28), numerator: BigInt(20), denominator: BigInt(1000) },
  { fromDay: BigInt(29), toDay: BigInt(99), numerator: BigInt(25), denominator: BigInt(1000) },
  { fromDay: BigInt(100), toDay: BigInt(135), numerator: BigInt(30), denominator: BigInt(1000) },
] as DepositRewardSchedulePeriod[];

export const depositRewardWithdrawalRates = {
  user: BigInt(70),
  commission: BigInt(10),
  dev: BigInt(10),
  vesting: BigInt(10),
};